const createListener = () => {
  let callbacks = []
  const subscribe = (fn, { unique = false } = {}) => {
    if (typeof fn !== 'function') {
      throw new Error('[Cart] subscribe only accept function')
    }

    const exists = unique
      ? callbacks.filter(callback => callback === fn).length > 0
      : false

    if (!exists) {
      callbacks.push(fn)
    }
  }

  const unsubscribe = fn => {
    callbacks = callbacks.filter(callback => callback !== fn)
  }

  const notify = data => {
    callbacks.forEach(callback => callback(data))
  }

  return {
    subscribe,
    unsubscribe,
    notify,
  }
}

export default createListener